"use client";
import { useState, useEffect } from "react";
import { FaPlay, FaTimes } from "react-icons/fa";
import Button from "./Button"; // adjust import if needed

const SuccessStory = () => {
  const [open, setOpen] = useState(false);

  // Close on ESC
  useEffect(() => {
    const esc = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, []);

  return (
    <>
      {/* ✅ MODERN DIAGONAL SECTION */}
      <section className="relative w-full mt-16 md:mt-24 py-20 px-6 md:px-20 overflow-hidden bg-primary_dark text-white">
        {/* ✅ DIAGONAL BACKGROUND SHAPE */}
        <div className="absolute -top-32 -left-32 w-[140%] h-[140%] bg-gradient-to-br from-primary_red/30 via-transparent to-transparent rotate-[-8deg]" />

        <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
          {/* ✅ LEFT — TEXT CONTENT */}
          <div>
            <h3 className="uppercase tracking-widest text-primary_red font-bold text-sm mb-4">
              Real Life. Real Impact.
            </h3>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight mb-6">
              One Transplant.
              <span className="block text-primary_red">
                A Second Chance At Life.
              </span>
            </h1>

            <p className="text-lg text-white/90 max-w-xl mb-8">
              “Thanks to the Sickle Cell Foundation, I received my bone marrow
              transplant and today I live healthier, stronger, and hopeful.”
            </p>

            <p className="font-semibold tracking-wide mb-10">
              — Bone Marrow Transplant Beneficiary
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="https://sicklecellfoundation.com/our-impact"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  classes="px-7 py-3 bg-primary_red font-bold rounded-md text-sm hover:bg-primary_red/80 transition"
                  text="Read More Stories"
                />
              </a>

              <button
                onClick={() => setOpen(true)}
                className="px-7 py-3 border border-white/40 rounded-md text-sm hover:bg-white hover:text-black transition"
              >
                Watch Video
              </button>
            </div>
          </div>

          {/* ✅ RIGHT — FLOATING VIDEO CARD */}
          <div
            onClick={() => setOpen(true)}
            className="relative group w-full max-w-md mx-auto h-[260px] rounded-xl overflow-hidden cursor-pointer shadow-2xl bg-black"
          >
            <img
              src="/assets/bmt/testimonial-cover.png"
              alt="Testimonial"
              className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
            />

            {/* ✅ PLAY BUTTON */}
            <div className="absolute inset-0 flex items-center justify-center bg-black/40">
              <div className="w-16 h-16 bg-primary_red text-white rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition">
                <FaPlay className="ml-1 text-lg" />
              </div>
            </div>

            {/* ✅ GEN-Z BADGE */}
            <div className="absolute top-4 left-4 bg-primary_red text-white text-xs font-bold px-3 py-1 rounded-full tracking-wide shadow">
              PATIENT STORY
            </div>
          </div>
        </div>
      </section>

      {/* ✅ VIDEO MODAL */}
      {open && (
        <div
          className="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center px-4"
          onClick={() => setOpen(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-5xl aspect-video bg-black rounded-xl overflow-hidden shadow-2xl"
          >
            <button
              onClick={() => setOpen(false)}
              className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-black/70 text-white flex items-center justify-center hover:bg-primary_red transition"
            >
              <FaTimes />
            </button>

            <iframe
              src="https://drive.google.com/file/d/1r2WiFUGdY7HvrffzT2tY8kTGDIuD2Zj3/preview"
              className="w-full h-full"
              allow="autoplay"
              allowFullScreen
              title="Testimonial Video"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SuccessStory;
